module.exports = __webpack_public_path__ + "img/logo-enst-air.88d1a89e.png";